import { CountUp } from "countup.js";

let inView = require("in-view");

/**
 * Initializes number counter module using inView and CountUp libraries
 * Number counter wrapper must have assigned class "number-counter"
 * Numbers must contain attribute "data-number-counter", value of "data-number"-attribute of this element will be used
 * as target number
 */
export default function InitNumberAnimation() {
	const clientsInfos = document.querySelectorAll(".clients-info");
	if (clientsInfos.length === 0) return;

	clientsInfos.forEach((clientsInfo) => {
		clientsInfo.innerHTML = clientsInfo.innerHTML.replace(/\d+/g, '<span data-number="$&">$&</span>');
	});

	inView(".clients-info").on("enter", () => {
		AnimateNumbers();
	});
	AnimateNumbers();
}

function AnimateNumbers() {
	const numbers = document.querySelectorAll(".clients-info *[data-number]");

	if (numbers.length === 0) return;

	numbers.forEach((number) => {
		const value = parseInt(number.dataset.number);
		const numAnim = new CountUp(number, value, {
			duration: 2.5,
		});

		if (!numAnim.error) numAnim.start();
		else throw new Error(numAnim.error);
	});
}
